import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "area-projects" }
const _hoisted_2 = {
  key: 0,
  class: "area-card-project"
}
const _hoisted_3 = { class: "image-card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "area-txt-and-buttons" }
const _hoisted_6 = { class: "area-tech" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Tech: ", -1)
const _hoisted_8 = { class: "display-buttons" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalViewProject = _resolveComponent("ModalViewProject")!

  return (_openBlock(), _createElementBlock("div", {
    id: "projects",
    class: _normalizeClass({'bg-projects-dark': _ctx.darkTheme, 'bg-projects-light': !_ctx.darkTheme})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.statusModal)
        ? (_openBlock(), _createBlock(_component_ModalViewProject, {
            key: 0,
            statusModal: _ctx.statusModal,
            changeStatusModal: _ctx.changeStatusModal,
            projectSelectedAfterClick: _ctx.projectSelectedAfterClick
          }, null, 8, ["statusModal", "changeStatusModal", "projectSelectedAfterClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, [
        _createElementVNode("span", {
          class: _normalizeClass({'text-dark': _ctx.darkTheme, 'text-light': !_ctx.darkTheme})
        }, "Projetos", 2)
      ])
    ]),
    (_ctx.myProjects)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myProjects.value, (projects, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["card-project", {'card-dark': _ctx.darkTheme, 'card-light': !_ctx.darkTheme}]),
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: projects.img
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", null, _toDisplayString(projects.name), 1),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatTechItems(projects.tech)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn-view-more",
                  onClick: ($event: any) => (_ctx.changeStatusModal(projects))
                }, " Ver mais ", 8, _hoisted_9),
                _createElementVNode("a", {
                  href: projects.url,
                  target: "_blank"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-live-demo", {'btn-live-demo-light': !_ctx.darkTheme}])
                  }, " Live Demo ", 2)
                ], 8, _hoisted_10)
              ])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}